export const config = {
  docsBannerInfo: {
    enabled: true,
    message: 'Available in the US only',
  },
}
